//components/Footer/index.jsx

import React from 'react'
import Link from 'gatsby-link'
import './Footer.scss';

class Footer extends React.Component {

	constructor(props) {
		super(props);  

    this.state = {
			isOpen: false,
    };

	}

  render() {
    return (
			<div className="footer-main">
				<svg id="curveDownColorFooter" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
						<path d="M0 0 C 50 100 80 100 100 0 Z"/>
					</svg>
				<div className="footer-center">
					{/* &copy;  { new Date().getFullYear() } */}
				</div>
			</div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx